import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ErrorCodeExpansionPanelModule } from '@portal-core/errors/components/error-code-expansion-panel/error-code-expansion-panel.module';
import { FormControlErrorMessageModule } from '@portal-core/forms/components/form-control-error-message/form-control-error-message.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { ProjectFilePickerInputModule } from '@portal-core/project-files/components/project-file-picker-input/project-file-picker-input.module';
import { ProjectFilesImageDialogComponent } from '@portal-core/project-files/components/project-files-image-dialog/project-files-image-dialog.component';
import { DropdownArrowModule } from '@portal-core/ui/forms/components/dropdown-arrow/dropdown-arrow.module';
import { FilePickerModule } from '@portal-core/ui/forms/components/file-picker/file-picker.module';
import { StylePickerInputModule } from '@portal-core/ui/style-picker/components/style-picker/style-picker-input.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';

@NgModule({
  declarations: [
    ProjectFilesImageDialogComponent
  ],
  imports: [
    McColorModule,
    CommonModule,
    ReactiveFormsModule,
    ErrorCodeExpansionPanelModule,
    LoaderModule,
    DropdownArrowModule,
    MatFormFieldModule,
    MatToolbarModule,
    MatIconModule,
    FormControlErrorMessageModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    FilePickerModule,
    StylePickerInputModule,
    ProjectFilePickerInputModule
  ],
  exports: [
    ProjectFilesImageDialogComponent
  ]
})
export class ProjectFilesImageDialogModule { }
